import { createSlice } from '@reduxjs/toolkit';

const loadTasksFromLocalStorage = () => {
  const tasks = localStorage.getItem('tasks');
  return tasks ? JSON.parse(tasks) : [];
};

const saveTasksToLocalStorage = (tasks) => {
  localStorage.setItem('tasks', JSON.stringify(tasks));
};

const todoListSlice = createSlice({
  name: 'tasks',
  initialState: {
    tasks: [],
    taskText: '',
    taskPriority: 'low',
    taskDate: new Date().toISOString().split('T')[0],
    sortType: '',
    sortOrder: 'asc',
    filterType: 'all',
    error: '',
    originalOrder: loadTasksFromLocalStorage() // Загрузка задач из локального хранилища
  },
  reducers: {
    ChangeTaskText: (state, action) => {
      state.taskText = action.payload;
    },
    ChangeTaskPriority: (state, action) => {
      state.taskPriority = action.payload;
    },
    ChangeTaskDate: (state, action) => {
      state.taskDate = action.payload;
    },
    AddTask: (state) => {
      if (!state.taskText.trim()) {
        state.error = 'Task name cannot be empty';
        return;
      }
      state.error = '';
      const newTask = {
        id: Date.now(),
        text: state.taskText,
        priority: state.taskPriority,
        date: state.taskDate,
        createdAt: new Date().toISOString(),
        completed: false,
      };
      state.tasks.push(newTask);
      state.originalOrder.push(newTask); // Сохраняем в исходный порядок
      saveTasksToLocalStorage(state.originalOrder); // Сохраняем задачи в локальное хранилище
      state.taskText = '';
    },
    ChangeTaskState: (state, action) => {
      const task = state.tasks.find(task => task.id === action.payload);
      if (task) {
        task.completed = !task.completed;
      }
    },
    DeleteTask: (state, action) => {
      state.tasks = state.tasks.filter(task => task.id !== action.payload);
      state.originalOrder = state.originalOrder.filter(task => task.id !== action.payload); // Удаляем из исходного порядка
      saveTasksToLocalStorage(state.originalOrder); // Обновляем локальное хранилище
    },
    EditTask: (state, action) => {
      const { id, newText, newPriority, newDate } = action.payload;
      const task = state.tasks.find(task => task.id === id);
      if (task) {
        task.text = newText;
        task.priority = newPriority;
        task.date = newDate;
      }
    },
    DeleteAll: (state) => {
      state.tasks = [];
      state.originalOrder = []; // Очищаем исходный порядок
      localStorage.removeItem('tasks'); // Удаляем задачи из локального хранилища
    },
    RestoreOriginalOrder: (state) => {
      state.tasks = loadTasksFromLocalStorage(); // Восстанавливаем исходный порядок из локального хранилища
    },
    SetSortType: (state, action) => {
      state.sortType = action.payload;
    },
    SetSortOrder: (state, action) => {
      state.sortOrder = action.payload;
    },
    SetFilterType: (state, action) => {
      state.filterType = action.payload;
    },
    SetError: (state, action) => {
      state.error = action.payload;
    }
  },
});

export const {
  ChangeTaskText,
  ChangeTaskPriority,
  ChangeTaskDate,
  AddTask,
  ChangeTaskState,
  DeleteTask,
  EditTask,
  DeleteAll,
  RestoreOriginalOrder,
  SetSortType,
  SetSortOrder,
  SetFilterType,
  SetError
} = todoListSlice.actions;

export default todoListSlice.reducer;
